import { DropdownPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query"
import {
  getArticulosByFilter,
  getArticulosContactByFilter,
} from "api/Articulo.service"
import { ArticuloReadingSimpleDtoProps } from "api/DTOs/ArticuloReadingSimpleDto"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { useImpuestoEmpresaNew } from "api/ImpuestoEmpresa.hook"
import { GetArticulosByContactoQueryDtoPropsIPagedEnumerableProps } from "api/Schemas/GetArticulosByContactoQueryDtoIPagedEnumerable"
import { GetArticulosByFiltersQueryDtoIPagedEnumerableProps } from "api/Schemas/GetArticulosByFiltersQueryDtoIPagedEnumerable"
import { ArticuloSelectedProps } from "features/Crear/pages/FormCreacionDocumento/Components/SelectedArticlesDocument/SelectedArticlesDocument"
import { MODES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import { InputText } from "primereact/inputtext"
import { useCallback, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"

const SearchArticuloTableDocument = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dropdownRef = useRef<any>(null)

  const [filter, setFilter] = useState<string>("")
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [articles, setArticles] = useState<any>([])
  const { impuestoEmpresa } = useImpuestoEmpresaNew({
    EmpresaId: values?.empresaActiva?.id,
    TipoImpuestoEmpresa:
      values.documentoType.mode === MODES_DOCUMENTOS.VENTA ? 1 : 0,
    EsActivo: true,
    IsPagingEnabled: false,
  })

  const {
    data: articulos,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["getArticulosByFilter", filter, values.librador.id],
    queryFn: async ({ pageParam }: $TSMigrationFixMe) => {
      return values.documentoType.mode === MODES_DOCUMENTOS.VENTA
        ? getArticulosByFilter({
            SkipCount: pageParam,
            Concepto: filter,
            EsDeCompra: false,
          })
        : values.config.isArticlesProveredor
        ? getArticulosContactByFilter({
            queryParams: {
              Concepto: filter,
              SkipCount: pageParam,
              EsDeCompra: false,
            },
            id: values.librador.id,
          })
        : getArticulosByFilter({
            SkipCount: pageParam,
            Concepto: filter,
            EsDeCompra: true,
          })
    },
    getNextPageParam: (
      lastPage:
        | GetArticulosByFiltersQueryDtoIPagedEnumerableProps
        | GetArticulosByContactoQueryDtoPropsIPagedEnumerableProps
    ) => {
      return lastPage?.currentPage &&
        lastPage.currentPage * 10 < lastPage.totalCount
        ? lastPage?.currentPage * 10
        : undefined
    },
    initialPageParam: 0,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    retry: false,
  })

  useEffect(() => {
    articulos &&
      articulos.pages &&
      articulos.pages.length > 0 &&
      articulos.pages[0].currentPage &&
      setArticles(articulos)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articulos])

  const articulosList =
    articles?.pages
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ?.flatMap((page: $TSMigrationFixMe) => page?.items)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .filter((item: $TSMigrationFixMe) => item) || []

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const loadMoreData = (event: $TSMigrationFixMe) => {
    if (!isFetchingNextPage && event.last === articulosList.length) {
      if (
        articulos &&
        articulos.pages &&
        articulos.pages.length > 0 &&
        articulosList.length <= articulos.pages[0].totalCount
      ) {
        fetchNextPage()
      }
    }
  }

  const recalculateTotal = useCallback(
    (updatedConceptos: ArticuloSelectedProps[]) => {
      const totalValue = updatedConceptos.reduce(
        (total: number, concepto: ArticuloSelectedProps) => {
          return total + concepto.cantidad * concepto.precioVenta
        },
        0
      )
      const cantidadValue = updatedConceptos.reduce(
        (total: number, concepto: ArticuloSelectedProps) => {
          return total + concepto.cantidad
        },
        0
      )

      setFieldValue("total", totalValue)
      setFieldValue("cantidadTotalArticulos", cantidadValue)
    },
    [setFieldValue]
  )

  const handleAddArticle = useCallback(
    (evento: ArticuloSelectedProps) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const userTaxeSelected: ImpuestoEmpresaReadingDtoProps | any =
        impuestoEmpresa?.items?.find(
          // @ts-expect-error TS(2769): No overload matches this call.
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ({ tipo, valor }: ImpuestoEmpresaReadingDtoProps) =>
            tipo ===
              (values.documentoType.mode === MODES_DOCUMENTOS.VENTA ? 1 : 0) &&
            valor === 21
        )

      const updatedConceptos = [
        ...values.conceptos,
        {
          ...evento,
          cantidad: 1,
          impuestoArticuloTipoId: userTaxeSelected.id,
          impuestoArticuloPorcentaje: userTaxeSelected.valor,
          impuestoNombre: userTaxeSelected.nombre,
          total: evento.precioVenta,
          cuentaContableId: values.cuentaContableId ?? null,
          index: values.conceptos.length + 1,
        },
      ]
      setFieldValue("conceptos", updatedConceptos)
      recalculateTotal(updatedConceptos)
    },
    [
      impuestoEmpresa?.items,
      values.conceptos,
      values.cuentaContableId,
      values.documentoType.mode,
      setFieldValue,
      recalculateTotal,
    ]
  )

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const addArtcileTemplate = ({ ...props }: $TSMigrationFixMe) => {
    return (
      <div
        className='tw-w-full tw-h-10 tw-p-4'
        onClick={() => {
          filter &&
            handleAddArticle({
              categorias: [],
              concepto: filter,
              id: uuidv4(),
              cantidad: 1,
              numeroReferencia: "",
              precioVenta: 0,
              thumbnailBase64: "",
              thumbnailMediaType: "",
              impuestoArticuloPorcentaje: 0,
              cuentaContableId: null,
            })
          props.resetFilter()
          dropdownRef.current.hide()
        }}
      >
        <div
          className={`${
            !filter ? "" : "tw-cursor-pointer"
          } tw-w-full tw-h-full tw-flex tw-justify-start tw-items-center tw-pl-4 tw-hover:bg-background tw-rounded`}
        >
          + {t("carrito.addArticle")}: {filter ?? ""}
        </div>
      </div>
    )
  }

  const onArticuloSelect = ({ value }: { value: string }) => {
    const selectedArticulo = articulosList.find(
      (item: ArticuloReadingSimpleDtoProps) => item.id === value
    )
    handleAddArticle({ ...selectedArticulo, id: uuidv4() })
    setFilter("")
  }

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  const onFilterArticle = ({ filter }: { filter: string }) => {
    setFilter(filter)
  }
  const [newValueCompra, setNewValueCompra] = useState("")

  return (
    <div className='tw-flex tw-justify-start'>
      {articulosList.length > 0 ? (
        <DropdownPrimeReact
          panelClassName='!tw-z-50 !tw-max-w-[600px] tw-h-fit'
          value={null}
          inputRef={dropdownRef}
          onChange={onArticuloSelect}
          options={articulosList}
          optionLabel='concepto'
          optionValue='id'
          className='!tw-max-w-full !tw-w-full !tw-border-none !tw-bg-transparent !tw-h-10 tw-items-center tw-align-middle !tw-p-0 !tw-rounded-t-none !tw-rounded-b hover:!tw-bg-neutral-10 hover:!tw-shadow '
          filter
          filterBy='concepto'
          filterPlaceholder={`${t("carrito.searchArticle")}`}
          placeholder={`${filter || `${t("carrito.searchAddArticle")}`}`}
          resetFilterOnHide
          filterMatchMode='contains'
          virtualScrollerOptions={{
            lazy: true,
            onLazyLoad: loadMoreData,
            itemSize: 38,
            showLoader: false,
          }}
          emptyFilterMessage={
            <p>{t("cuentasContables.notElementAccountsFilter")}</p>
          }
          emptyMessage={<p>{t("cuentasContables.notElementAccounts")}</p>}
          panelFooterTemplate={addArtcileTemplate}
          filterInputAutoFocus
          onFilter={onFilterArticle}
        />
      ) : (
        <div className='tw-relative tw-w-full'>
          <div className='tw-relative tw-w-full'>
            <InputText
              value={newValueCompra}
              onChange={(event) => setNewValueCompra(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleAddArticle({
                    categorias: [],
                    concepto: newValueCompra,
                    id: uuidv4(),
                    numeroReferencia: "",
                    precioVenta: 0,
                    cantidad: 1,
                    thumbnailBase64: "",
                    thumbnailMediaType: "",
                    impuestoArticuloPorcentaje: 0,
                    cuentaContableId: null,
                  })
                  setNewValueCompra("")
                }
              }}
              className='!tw-w-full !tw-border-none !tw-shadow-none'
            />
            {!newValueCompra && (
              <div className='tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-items-center tw-px-2 tw-pointer-events-none'>
                <FontAwesomeIcon
                  icon={["fal", "magnifying-glass"]}
                  className='tw-mr-2'
                />
                {t("carrito.addArticle")}
              </div>
            )}
          </div>
          {newValueCompra && (
            <div
              onClick={() => {
                handleAddArticle({
                  categorias: [],
                  concepto: newValueCompra,
                  id: uuidv4(),
                  numeroReferencia: "",
                  precioVenta: 0,
                  cantidad: 1,
                  thumbnailBase64: "",
                  thumbnailMediaType: "",
                  impuestoArticuloPorcentaje: 0,
                  cuentaContableId: null,
                })
                setNewValueCompra("")
              }}
              className='tw-absolute tw-text-text !tw-bg-white tw--bottom-0 tw-w-full tw-rounded tw-cursor-pointer tw-border tw-border-neutral-25 tw-py-2 tw-text-left tw-px-2'
            >
              + {t("carrito.addArticle")}: {newValueCompra ?? ""}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default SearchArticuloTableDocument
